var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9814 23.1826L11.1689 21.5326C4.73145 15.6951 0.481445 11.8326 0.481445 7.12012C0.481445 3.25762 3.50645 0.245117 7.35645 0.245117C9.53145 0.245117 11.6189 1.25762 12.9814 2.84512C14.3439 1.25762 16.4314 0.245117 18.6064 0.245117C22.4564 0.245117 25.4814 3.25762 25.4814 7.12012C25.4814 11.8326 21.2314 15.6951 14.7939 21.5326L12.9814 23.1826Z",
    fill: "#F24E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeart);
export default __webpack_public_path__ + "static/media/ic-heart.994c5b544c54d77bcac16e58cbc2a897.svg";
export { ForwardRef as ReactComponent };